export const INITIAL_STATE = { 
    positions:[],
};




// WEBPACK FOOTER //
// ./src/reducers/state/ComplaintPositions.js